// extracted by mini-css-extract-plugin
export const outer = "movies-module--outer--2fMQT";
export const banner = "movies-module--banner--s4px1";
export const card = "movies-module--card--13KAG";
export const imageContainer = "movies-module--image-container--le8qr";
export const movieImage = "movies-module--movie-image--a0VaM";
export const movieImageHover = "movies-module--movie-image-hover--2kjSt";
export const date = "movies-module--date--2ne0U";
export const userImage = "movies-module--user-image--2Xg0-";
export const extraDetails = "movies-module--extra-details--2TWfr";
export const show = "movies-module--show--w90W_";
export const button = "movies-module--button--5Eqeh";
export const buttonActive = "movies-module--button-active--k4gQJ";
export const cardOuter = "movies-module--card-outer--3hPen";